<template>
  <div id="my-music" class="big-m-t big-m-b">
      <div class="d-f fd-c ai-c p-hor">
        <SongsPlaylistProfile
          :playlist-position="0"
          @play-select-song="playSelectedSongAsync"
          :playlist="uploadsList"
          :is-own-profile="true"
          :edit-buttons="true"
        />
      </div>
  </div>
</template>

<script>
import { rtdb } from '@/db.js'
import { mapGetters, mapActions } from "vuex"
import SongsPlaylistProfile from '@/components/profile/SongsPlaylistProfile'
import PlayerMixin from '@/mixins/PlayerMixin'

export default {
  name: 'MyMusic',
  components: {
    SongsPlaylistProfile
  },
  mixins: [PlayerMixin],
  data() {
    return {
      uploadsList: {
        title: 'My Music',
        songs: null,
      },
    }
  },
  mounted() {
    this.getUploads()
  },
  computed: {
    ...mapGetters(['getUser']),
  },
  methods: {
    ...mapActions(['replacePlaylist']),

    async playSelectedSongAsync(payload) {
      await this.replacePlaylist({
        title: 'My Music',
        songs: this.uploadsList.songs,
      })
      this.playSelectedSong(payload)
    },

    getUploads() {
      const usersMusicRef = rtdb.ref(`userMusic/${this.getUser.data.uid}`)
      usersMusicRef.on('value', (snapshot) => {
        const arr = []
        snapshot.forEach(x => {
          arr.push(x.val())
        })
        this.$set(this.uploadsList, 'songs', arr)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
